import { FC } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { FrequencyDropdown, FrequencyDropdownProps } from '../../UI';
import { contributionFieldValuesFromForm, isContributionFieldMissing, manualPair } from '../contributionPairs';
import { useContributionDerivedFromIncomeSource } from '../hooks/useContributionDerivedFromIncomeSource';
import { InvestmentFormValues } from '../types';
import { DerivedFromIncomeSourceTooltip } from './DerivedFromIncomeSourceTooltip';

interface InvestmentRecurringContributionsFrequencyDropdownProps
  extends Pick<FrequencyDropdownProps, 'dropdownMenuClassName'> {}

export const InvestmentRecurringContributionsFrequencyDropdown: FC<
  InvestmentRecurringContributionsFrequencyDropdownProps
> = (dropdownProps) => {
  const { control } = useFormContext<InvestmentFormValues>();
  const contributionDerivedFromIncomeSource = useContributionDerivedFromIncomeSource();
  const {
    field,
    fieldState: { error },
  } = useController<InvestmentFormValues, 'recurringContribution.frequency'>({
    control,
    name: 'recurringContribution.frequency',
    rules: {
      // Manual pair is "both or neither": a frequency needs an amount.
      validate: (_frequency, formValues) =>
        !isContributionFieldMissing(manualPair, 'frequency', contributionFieldValuesFromForm(formValues)),
    },
  });

  const dropdown = (
    <FrequencyDropdown
      {...field}
      {...dropdownProps}
      withClearSelection
      status={contributionDerivedFromIncomeSource ? 'disabled' : error ? 'errored' : 'normal'}
      onChange={(value) => field.onChange(value)}
    />
  );

  return (
    <DerivedFromIncomeSourceTooltip derived={contributionDerivedFromIncomeSource}>{dropdown}</DerivedFromIncomeSourceTooltip>
  );
};
